import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=330ad225&scoped=true&"
import script from "./contactForm.vue?vue&type=script&lang=js&"
export * from "./contactForm.vue?vue&type=script&lang=js&"
import style0 from "./contactForm.vue?vue&type=style&index=0&id=330ad225&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ad225",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330ad225')) {
      api.createRecord('330ad225', component.options)
    } else {
      api.reload('330ad225', component.options)
    }
    module.hot.accept("./contactForm.vue?vue&type=template&id=330ad225&scoped=true&", function () {
      api.rerender('330ad225', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/contactForm.vue"
export default component.exports